import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class PurchaseItemPriceService {
    constructor(http) {
        this.http = http;
        this.singular = 'purchase item price';
        this.plural = 'purchase item prices';
        this.editor = PLATFORM.moduleName('pages/quote-setup/purchase-item-prices/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`purchase-item-prices/filter/${loadOptions}`);
        return await response.json();
    }

    async create(purchaseItemPrice) {
        await this.http.fetch('purchase-item-prices', { method: 'POST', body: json(purchaseItemPrice) });
    }

    async update(purchaseItemPrice) {
        await this.http.fetch(`purchase-item-prices/${purchaseItemPrice.id}`, { method: 'PUT', body: json(purchaseItemPrice) });
    }

    async delete(id) {
        await this.http.fetch(`purchase-item-prices/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`purchase-item-prices/${id}`);
        return await response.json();
    }
}
